import React from "react";
import { SVGProps } from "../../svgData";

export default ({ defaultColor, selectedColor, isSelected }: SVGProps) => {
  const color = isSelected ? selectedColor : defaultColor;

  return (
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="tag-solid 1">
        <path
          id="Vector"
          d="M0 2.99944V8.33873C0 8.94587 0.239286 9.52801 0.667857 9.95658L6.95357 16.2423C7.84643 17.1352 9.29286 17.1352 10.1857 16.2423L14.9536 11.4744C15.8464 10.5816 15.8464 9.13516 14.9536 8.2423L8.66786 1.95658C8.23929 1.52801 7.65714 1.28873 7.05 1.28873L1.71429 1.28516C0.767857 1.28516 0 2.05301 0 2.99944ZM4 4.1423C4.3031 4.1423 4.59379 4.26271 4.80812 4.47703C5.02245 4.69136 5.14286 4.98205 5.14286 5.28516C5.14286 5.58826 5.02245 5.87895 4.80812 6.09328C4.59379 6.30761 4.3031 6.42801 4 6.42801C3.6969 6.42801 3.40621 6.30761 3.19188 6.09328C2.97755 5.87895 2.85714 5.58826 2.85714 5.28516C2.85714 4.98205 2.97755 4.69136 3.19188 4.47703C3.40621 4.26271 3.6969 4.1423 4 4.1423Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
